import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f143dbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "themes-list__item__name" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "themes-list__item__text" }
const _hoisted_5 = { class: "themes-list themes-list--mobile" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "themes-list__item__name" }

import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useEditorStore } from '@/store/editor';
import { ITheme } from '@/store/editor/types';
import { useCommonStore } from '@/store/common';
import { cloneDeep } from 'lodash';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiBottomModal from '@/components/UI/AiBottomModal/AiBottomModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemesSettings',
  setup(__props) {

const { generateImageData, themesList } = storeToRefs(useEditorStore());
const { isMobile } = storeToRefs(useCommonStore());

const activeThemeId = ref<string | null>(null);
const showThemesModal = ref<boolean>(false);

const themesLength = computed(() => (isMobile.value ? 8 : 100));

const themesListComputed = computed<ITheme[]>(() => {
  let result = cloneDeep(themesList.value);
  if (result.length > themesLength.value) {
    result = result.slice(0, themesLength.value);
    if (generateImageData.value.theme !== null) {
      const index = result.findIndex((themeItem: ITheme) => themeItem.id === generateImageData.value.theme);
      if (index === -1) {
        result.splice(0, 1, generateImageData.value.theme);
      }
    }
  }
  return result;
});

const randomTheme = computed(() => themesList.value[Math.floor(Math.random() * themesList.value.length)]);

const selectTheme = (theme: ITheme): void => {
  activeThemeId.value = theme.id;
  generateImageData.value.theme = theme;
};

const toggleThemesModalHandler = (): void => {
  showThemesModal.value = !showThemesModal.value;
};

onMounted(() => {
  if (themesList.value.length) {
    let defaultTheme = themesList.value[0];
    if (generateImageData.value.theme) {
      defaultTheme = generateImageData.value.theme;
    }
    activeThemeId.value = defaultTheme.id;
    generateImageData.value.theme = defaultTheme;
  }
  if (generateImageData.value.theme) {
    activeThemeId.value = generateImageData.value.theme.id;
  }
});

watch(themesList, () => {
  if (themesList.value.length) {
    let defaultTheme = themesList.value[0];
    if (generateImageData.value.theme) {
      defaultTheme = generateImageData.value.theme;
    }
    activeThemeId.value = defaultTheme.id;
    generateImageData.value.theme = defaultTheme;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["themes-list", {'themes-list--mobile': _unref(isMobile)}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themesListComputed.value, (theme) => {
        return (_openBlock(), _createBlock(AiClearButton, {
          key: theme.id,
          class: _normalizeClass(["themes-list__item", { 'themes-list__item--selected': activeThemeId.value === theme.id }]),
          onClick: ($event: any) => (selectTheme(theme))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: theme.url,
              alt: theme.name
            }, null, 8, _hoisted_1),
            _createElementVNode("div", _hoisted_2, _toDisplayString(theme.name), 1)
          ]),
          _: 2
        }, 1032, ["class", "onClick"]))
      }), 128)),
      (_unref(themesList).length > themesListComputed.value.length)
        ? (_openBlock(), _createBlock(AiClearButton, {
            key: 0,
            class: "themes-list__item themes-list__item--more",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showThemesModal.value = true))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: randomTheme.value.url,
                alt: randomTheme.value.name
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('editor.settings.more')) + " " + _toDisplayString(_unref(themesList).length - themesListComputed.value.length), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(AiBottomModal, {
          key: 0,
          "show-modal": showThemesModal.value,
          "handle-toggle": toggleThemesModalHandler,
          title: _ctx.$t('editor.settings.theme')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(themesList), (theme) => {
                return (_openBlock(), _createBlock(AiClearButton, {
                  key: theme.id,
                  class: _normalizeClass(["themes-list__item", { 'themes-list__item--selected': activeThemeId.value === theme.id }]),
                  onClick: ($event: any) => (selectTheme(theme))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: theme.url,
                      alt: theme.name
                    }, null, 8, _hoisted_6),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(theme.name), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["show-modal", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})